import React from "react";
import Button from "shared/components/button";
import { useAuth } from "shared/context/auth";
import { useCopies } from "shared/hooks/useCopies";
import { useGetBulkTicketDetails } from "../../dataloader";
import { getBulkTicketPurchaseSummary } from "../../utils";
import { ParticipantRole } from "shared/enums/ParticipantRole";

export default function BulkTicketNoteInPurchaseTicket(props: {
  openAssignTicketToSelfHandler: () => void;
  bulkTicketId: string;
}) {
  const { userDetail } = useAuth();
  const copies = useCopies();

  const isBulkTicketAdmin = React.useMemo(() => {
    return userDetail?.participantRoles.includes(ParticipantRole.BULK_TICKET_ADMIN);
  }, [userDetail?.participantRoles]);

  const { data = [] } = useGetBulkTicketDetails({
    registrationParticipantId: isBulkTicketAdmin ? userDetail?.id : undefined
  });

  const purchaseSummary = React.useMemo(() => getBulkTicketPurchaseSummary(data), [data]);

  const assignTicketOpenHandler = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      props.openAssignTicketToSelfHandler();
    },
    [props]
  );

  return purchaseSummary.unassigned > 0 ? (
    <Button.Link
      label={copies.get("assign.to.me")}
      onClick={assignTicketOpenHandler}
      className="assignTicket_noteBtn"
    />
  ) : null;
}
